import React, { useEffect, useMemo } from "react";

import Tooltip from "@mui/material/Tooltip";

import { ReactComponent as DASHBOARD } from "../../build/images/newSideMenu/dashboard.svg";
import { ReactComponent as CLIENTES } from "../../build/images/newSideMenu/clientes.svg";
import { ReactComponent as CASOS } from "../../build/images/newSideMenu/casos.svg";
import { ReactComponent as TAREFAS } from "../../build/images/newSideMenu/tarefas.svg";
import { ReactComponent as EQUIPES } from "../../build/images/newSideMenu/equipes.svg";
import { ReactComponent as NPSICON } from "../../build/images/newSideMenu/nps.svg";
import { ReactComponent as CALLCENTER } from "../../build/images/newSideMenu/call-center.svg";
import { ReactComponent as IconMoreOpt } from "../../build/images/newSideMenu/more-options.svg";
import { ReactComponent as MONITORIAS } from "../../build/images/newSideMenu/monitoria.svg";
import { ReactComponent as ATENDENTES } from "../../build/images/newSideMenu/atendentes.svg";
import { ReactComponent as HISTORICO } from "../../build/images/newSideMenu/historico.svg";
import { ReactComponent as RELATORIOS } from "../../build/images/newSideMenu/relatorios.svg";
import { ReactComponent as INGSUITE } from "../../build/images/newSideMenu/ing-suite.svg";
import { ReactComponent as CAMPANHAS } from "../../build/images/newSideMenu/campanhas.svg";
import { ReactComponent as FACEBOOKICON } from "../../build/images/newSideMenu/facebook.svg";
import { ReactComponent as INSTAGRAMICON } from "../../build/images/newSideMenu/instagram.svg";
import { ReactComponent as EMAIL } from "../../build/images/newSideMenu/email.svg";
import { ReactComponent as ATIVO } from "../../build/images/newSideMenu/ativo.svg";
import { ReactComponent as CONTATO } from "../../build/images/newSideMenu/contato.svg";
import { ReactComponent as MENSAGEM } from "../../build/images/newSideMenu/mensagem.svg";
import { EmptyWallet, CalendarTick as RESERVAS } from "iconsax-reactjs";
import { ReactComponent as AJUDA } from "../../build/images/attendanceIcons/icon-ajuda.svg";

import { useDispatch, useSelector } from "react-redux";

import "./new-side-menu.css";
import {
  AlterScreen,
  editClientWallet,
  getCompanys,
  GetHistory,
  GetHistoryCalls,
  GetInteractionsContact,
  GetNumbersContact,
  getTypeNumbers,
  RemoveRemoteNotifier,
  setIsOpenFaqDragable,
  ShowActiveCall,
  ShowInfoDisplay,
  ShowModalsMenu,
} from "../../actions";
import { connection_platform } from "../../services/api";
import MoreOptionsMenu from "./MoreOptionsMenu";
import Activecall from "../Activecall";
import MicroModal from "micromodal";
import Contact from "../Contact";
import TeamModal from "../../modals/TeamModal";
import { ingDeskService } from "../../services/IngDesk/ingDeskService";

export default function NewSideMenu() {
  const dispatch = useDispatch();
  const infoDisplay = useSelector((state) => state.infodisplay);
  const infoUsers = useSelector((state) => state.informationusers);
  const chat = useSelector((state) => state.chatinternal);
  const currentScreen = useSelector((state) => state.currentscreen);
  const ingFaqConditions = useSelector((state) => state.ingFaqConditions);

  const userName = useMemo(() => {
    const hasInfoUsers = Boolean(infoUsers);
    if (!hasInfoUsers) return null;
    const hasUserName = Boolean(infoUsers.username);
    if (!hasUserName) return null;
    return infoUsers.username;
  }, [infoUsers]);

  const backendIngDesk = useMemo(() => {
    const hasInfoUsers = Boolean(infoUsers);
    if (!hasInfoUsers) return null;
    const hasBackendIngDesk = Boolean(infoUsers.backendingdesk);
    if (!hasBackendIngDesk) return null;
    return infoUsers.backendingdesk;
  }, [infoUsers]);

  const permissionWallet = useMemo(() => {
    const hasInfoUsers = Boolean(infoUsers);
    if (!hasInfoUsers) return null;
    const hasPermissionWallet = Boolean(infoUsers.permissionWallet);
    if (!hasPermissionWallet) return null;
    return infoUsers.permissionWallet;
  }, [infoUsers]);

  const handleChangeScreen = (display) => {
    dispatch(ShowInfoDisplay(display));
    dispatch(AlterScreen(display));
    dispatch(GetHistoryCalls([]));
    dispatch(GetHistory([]));
    dispatch(getTypeNumbers([]));
    dispatch(GetInteractionsContact([]));
    dispatch(getCompanys([]));
    dispatch(GetNumbersContact([]));

    const isAtendentes = display === "Atendentes";
    if (isAtendentes) {
      dispatch(RemoveRemoteNotifier(chat.iduserout));
    }
  };

  const permissionsIngdesk = infoUsers.permissionsIngdesk;
  //opções visiveis
  const mainMenuItems = [
    {
      id: "Gestor",
      label: "Dashboard",
      tooltipLabel: "Dashboard",
      icon: <DASHBOARD />,
      iconFill: "stroke",
      active:
        infoUsers.supervisor === true && connection_platform.manager_screen_old,
    },
    {
      id: "Gestor2",
      label: "Dashboard",
      tooltipLabel: "Dashboard",
      icon: <DASHBOARD />,
      iconFill: "stroke",
      active:
        infoUsers.supervisor === true && connection_platform.manager_screen_new,
    },
    {
      id: "Clientes",
      label: "Clientes",
      tooltipLabel: "Clientes",
      icon: <CLIENTES />,
      iconFill: "stroke",
      active: true,
    },
    {
      id: "Equipes",
      label: "Equipes",
      tooltipLabel: "Equipes",
      icon: <EQUIPES />,
      iconFill: "stroke",
      active: true,
    },
    {
      id: "NPS",
      label: "Qualidade",
      tooltipLabel: "Qualidade",
      icon: <NPSICON />,
      iconFill: "fill",
      active: infoUsers.qualidade === true,
    },
    {
      id: "QualityAgent",
      label: "Call Center",
      tooltipLabel: "Call Center",
      icon: <CALLCENTER />,
      iconFill: "fill",
      active:
        infoUsers.gerente === true &&
        connection_platform.visibleCallCenter === true,
    },
    {
      id: "Casos",
      label: "Casos",
      tooltipLabel: "Casos",
      icon: <CASOS />,
      iconFill: "stroke",
      active: infoUsers.nameauth === "IngDesk",
      // placeToRender: "ingDeskArea",
    },
    {
      id: "FaqDragable",
      label: "Ajuda",
      tooltipLabel: "Ajuda",
      icon: <AJUDA />,
      iconFill: "fill",
      active: ingFaqConditions.isHelpActive,
      handleClick: () => {
        dispatch(setIsOpenFaqDragable(true));
      },
    },
  ];

  const hiddenItems = [
    {
      id: "Atendentes",
      label: "Atendentes",
      tooltipLabel: "Atendentes",
      icon: <ATENDENTES />,
      iconFill: "stroke",
      active: true,
      placeToRender: "top",
    },
    {
      id: "Monitorias",
      label: "Monitorias",
      tooltipLabel: "Monitorias",
      icon: <MONITORIAS />,
      iconFill: "stroke",
      active: infoUsers.supervisor === true,
      placeToRender: "top",
    },
    {
      id: "Historic",
      label: "Histórico",
      tooltipLabel: "Histórico",
      icon: <HISTORICO />,
      iconFill: "stroke",
      active: true,
      placeToRender: "top",
    },
    {
      id: "Campanhas",
      label: "Campanhas",
      tooltipLabel: "Campanhas",
      icon: <CAMPANHAS />,
      iconFill: "fill",
      active: infoUsers.supervisor === true && connection_platform.seeCampaigns,
      placeToRender: "top",
    },
    {
      id: "Email",
      label: "Email",
      tooltipLabel: "Email",
      icon: <EMAIL />,
      iconFill: "fill",
      active: connection_platform.isExistMail === true,
      placeToRender: "top",
    },
    // {
    //   id: "Relatorios",
    //   label: "Relatórios",
    //   tooltipLabel: "Relatórios",
    //   icon: <RELATORIOS />,
    //   iconFill: "stroke",
    //   active: infoUsers.gerente === true,
    //   placeToRender: "top",
    //   handleClick: () => {
    //     window.open(infoUsers.relatorio + "/ingweb.php?id=" + infoUsers.id);
    //   },
    // },
    {
      id: "Cadastros",
      label: "IngSuite",
      tooltipLabel: "IngSuite",
      icon: <INGSUITE />,
      iconFill: "fill",
      active:
        infoUsers.suporte === true ||
        infoUsers.supervisor === true ||
        infoUsers.gerente === true,
      placeToRender: "bottom",
      handleClick: () => {
        window.open(
          infoUsers.cadastros +
            "/ingweb.php?id=" +
            infoUsers.id +
            "&name=" +
            infoUsers.displayname
        );
      },
    },
    {
      id: "Facebook",
      label: "Facebook",
      tooltipLabel: "Facebook",
      icon: <FACEBOOKICON />,
      iconFill: "fill",
      active: connection_platform.buttonface === true,
      placeToRender: "bottom",
      handleClick: () => {
        window.open(
          "https://www.facebook.com/v18.0/dialog/oauth?app_id=6998422056945909&cbt=1707136787144&channel_url=https%3A%2F%2Fstaticxx.facebook.com%2Fx%2Fconnect%2Fxd_arbiter%2F%3Fversion%3D46%23cb%3Df7006076f88e87a2e%26domain%3Dcloud.ingweb.com.br%26is_canvas%3Dfalse%26origin%3Dhttps%253A%252F%252Fcloud.ingweb.com.br%253A3006%252Ff548a851e83ce79b4%26relation%3Dopener&client_id=6998422056945909&config_id=354636957178727&display=popup&domain=cloud.ingweb.com.br&e2e=%7B%7D&fallback_redirect_uri=https%3A%2F%2Fcloud.ingweb.com.br%3A3006%2Ftechprovider.html&locale=en_US&logger_id=fa4d3054a073c02fe&origin=1&override_default_response_type=true&redirect_uri=https%3A%2F%2Fstaticxx.facebook.com%2Fx%2Fconnect%2Fxd_arbiter%2F%3Fversion%3D46%23cb%3Df846fa9903170e641%26domain%3Dcloud.ingweb.com.br%26is_canvas%3Dfalse%26origin%3Dhttps%253A%252F%252Fcloud.ingweb.com.br%253A3006%252Ff548a851e83ce79b4%26relation%3Dopener%26frame%3Df3d16cc0f22e8295d&response_type=code&sdk=joey&version=v18.0",
          "about",
          "height=750,width=650"
        );
      },
    },
    {
      id: "Instagram",
      label: "Instagram",
      tooltipLabel: "Instagram",
      icon: <INSTAGRAMICON />,
      iconFill: "fill",
      active: connection_platform.buttoninstagram === true,
      placeToRender: "bottom",
      handleClick: () => {
        window.open(
          "https://www.facebook.com/v18.0/dialog/oauth?app_id=762256599016287&cbt=1707136787144&channel_url=https%3A%2F%2Fstaticxx.facebook.com%2Fx%2Fconnect%2Fxd_arbiter%2F%3Fversion%3D46%23cb%3Df7006076f88e87a2e%26domain%3Dcloud.ingweb.com.br%26is_canvas%3Dfalse%26origin%3Dhttps%253A%252F%252Fcloud.ingweb.com.br%253A3006%252Ff548a851e83ce79b4%26relation%3Dopener&client_id=6998422056945909&config_id=238253192682660&display=popup&domain=cloud.ingweb.com.br&e2e=%7B%7D&fallback_redirect_uri=https%3A%2F%2Fcloud.ingweb.com.br%3A3006%2Ftechprovider.html&locale=en_US&logger_id=fa4d3054a073c02fe&origin=1&override_default_response_type=true&redirect_uri=https%3A%2F%2Fstaticxx.facebook.com%2Fx%2Fconnect%2Fxd_arbiter%2F%3Fversion%3D46%23cb%3Df846fa9903170e641%26domain%3Dcloud.ingweb.com.br%26is_canvas%3Dfalse%26origin%3Dhttps%253A%252F%252Fcloud.ingweb.com.br%253A3006%252Ff548a851e83ce79b4%26relation%3Dopener%26frame%3Df3d16cc0f22e8295d&response_type=code&sdk=joey&version=v18.0",
          "about",
          "height=750,width=650"
        );
      },
    },
    {
      id: "IngDesk",
      label: "Tarefas",
      tooltipLabel: "Tarefas",
      icon: <TAREFAS />,
      iconFill: "stroke",
      active: permissionsIngdesk && permissionsIngdesk.tarefas.visualizacao,
      // active: infoUsers.nameauth === "IngDesk",
      placeToRender: "ingDeskArea",
    },
    {
      id: "Reservas",
      label: "Reservas",
      tooltipLabel: "Reservas",
      icon: <RESERVAS color="#757575" />,
      iconFill: "stroke",
      active: permissionsIngdesk && permissionsIngdesk.reservas.visualizacao,
      // active: infoUsers.nameauth === "IngDesk",
      placeToRender: "ingDeskArea",
    },
    {
      id: "CarteiraDeClientes",
      label: "Carteira De Clientes",
      tooltipLabel: "Carteira De Clientes",
      icon: <EmptyWallet size="24" color="#757575" />,
      iconFill: "stroke",
      active: permissionWallet && permissionWallet.visualizacao,
      // permissionsIngdesk &&
      // permissionsIngdesk.carteiraDeClientes &&
      // permissionsIngdesk.carteiraDeClientes.visualizacao,
      placeToRender: "ingDeskArea",
    },
  ];

  const filteredMainMenuItems = mainMenuItems.filter((item) => item.active);

  const topHiddenItems = hiddenItems.filter((item) => {
    return item.active && item.placeToRender === "top";
  });
  const bottomHiddenItems = hiddenItems.filter((item) => {
    return item.active && item.placeToRender === "bottom";
  });
  const menuItemsIngDesk = hiddenItems.filter((item) => {
    return item.active && item.placeToRender === "ingDeskArea";
  });

  const hasFilteredMainMenuItems = filteredMainMenuItems.length > 0;
  const hasHiddenItems = hiddenItems.filter((item) => item.active).length > 0;

  useEffect(() => {
    const hasInformation = Boolean(userName) && Boolean(backendIngDesk);
    if (!hasInformation) return;
    const getPermissionOfClientWallet = async () => {
      try {
        const profileInfos = await ingDeskService.getIngDeskIdProfile(
          backendIngDesk,
          userName
        );
        const hasProfileInfos = Boolean(profileInfos);
        if (!hasProfileInfos) return;
        const hasIdProfileAndToken =
          (Boolean(profileInfos.idProfile) || profileInfos.idProfile === 0) &&
          Boolean(profileInfos.token);

        if (!hasIdProfileAndToken) return;
        const response = await ingDeskService.getPermissions(
          backendIngDesk,
          profileInfos.idProfile,
          profileInfos.token
        );
        const hasData = Boolean(response) && Array.isArray(response.data);
        if (!hasData) return;
        const clientWalletPermission = response.data.find(
          (datum) => datum.id_tela_campo === 28
        );
        if (!Boolean(clientWalletPermission)) return;
        dispatch(editClientWallet(clientWalletPermission));
      } catch (error) {
        console.log("getPermissionOfClientWallet Error: ", error);
      }
    };

    getPermissionOfClientWallet();
  }, [userName, backendIngDesk, ingDeskService, dispatch]);

  return (
    <div>
      <div
        className={`new-side-menu ${
          infoDisplay.infodisplay === "Monitorias" ? "black-theme" : ""
        }`}
      >
        <ul className="new-side-menu__first-container">
          {hasFilteredMainMenuItems &&
            filteredMainMenuItems.map((menuItem, index) => {
              const isActive = infoDisplay.infodisplay === menuItem.id;
              return (
                <li
                  key={`${menuItem.id}--${index}`}
                  className={`new-side-menu__first-container__main-menu-item ${
                    isActive ? "active" : ""
                  }`}
                >
                  {isActive ? (
                    <button
                      className={`new-side-menu__first-container__main-menu-item__button ${menuItem.iconFill}`}
                      onClick={() => {
                        handleChangeScreen(menuItem.id);
                      }}
                    >
                      {menuItem.icon}
                    </button>
                  ) : (
                    <Tooltip
                      title={menuItem.tooltipLabel}
                      placement="right-start"
                      arrow
                      componentsProps={{
                        tooltip: {
                          sx: {
                            padding: "8px 16px",
                            fontFamily: "'Inter', sans-serif",
                            fontWeight: "400",
                            fontSize: "14px",
                            lineHeight: "19.6px",
                          },
                        },
                      }}
                    >
                      <button
                        className={`new-side-menu__first-container__main-menu-item__button ${menuItem.iconFill}`}
                        onClick={() => {
                          const hasHandleClick = !!menuItem.handleClick;
                          if (hasHandleClick) {
                            menuItem.handleClick();
                          } else {
                            handleChangeScreen(menuItem.id);
                          }
                        }}
                      >
                        {menuItem.icon}
                      </button>
                    </Tooltip>
                  )}

                  {isActive && (
                    <span className="new-side-menu__first-container__main-menu-item__text">
                      {menuItem.label}
                    </span>
                  )}
                </li>
              );
            })}
          {hasHiddenItems && (
            <li className="new-side-menu__first-container__more-options">
              <MoreOptionsMenu
                labelIcon={<IconMoreOpt />}
                menuItemsTop={topHiddenItems}
                menuItemsBottom={bottomHiddenItems}
                menuItemsIngDesk={menuItemsIngDesk}
                onClick={(display) => {
                  handleChangeScreen(display);
                }}
              />
            </li>
          )}
        </ul>
        <ul className="new-side-menu__second-container">
          <li className="new-side-menu__second-container__item">
            <Tooltip
              title="Mensagem para equipe"
              placement="right"
              arrow
              componentsProps={{
                tooltip: {
                  sx: {
                    padding: "8px 16px",
                    fontFamily: "'Inter', sans-serif",
                    fontWeight: "400",
                    fontSize: "14px",
                    lineHeight: "19.6px",
                  },
                },
              }}
            >
              <button
                className="new-side-menu__second-container__item__button-contact stroke"
                onClick={() => {
                  MicroModal.show("modal__mensagem-equipe");
                  dispatch(AlterScreen("ChatGrupo", currentScreen.screen));
                }}
              >
                <MENSAGEM />
              </button>
            </Tooltip>
          </li>
          <li className="new-side-menu__second-container__item">
            <Tooltip
              title="Contatos"
              placement="right"
              arrow
              componentsProps={{
                tooltip: {
                  sx: {
                    padding: "8px 16px",
                    fontFamily: "'Inter', sans-serif",
                    fontWeight: "400",
                    fontSize: "14px",
                    lineHeight: "19.6px",
                  },
                },
              }}
            >
              <button
                className="new-side-menu__second-container__item__button-contact stroke"
                onClick={() => {
                  dispatch(ShowModalsMenu("modal__agenda"));
                  MicroModal.show("modal__agenda");
                }}
              >
                <CONTATO />
              </button>
            </Tooltip>
          </li>
          <li className="new-side-menu__second-container__item">
            <Tooltip
              title="Falar com cliente"
              placement="right"
              arrow
              componentsProps={{
                tooltip: {
                  sx: {
                    padding: "8px 16px",
                    fontFamily: "'Inter', sans-serif",
                    fontWeight: "400",
                    fontSize: "14px",
                    lineHeight: "19.6px",
                  },
                },
              }}
            >
              <button
                className="new-side-menu__second-container__item__button"
                onClick={() => {
                  dispatch(ShowActiveCall("active"));
                }}
              >
                <ATIVO />
              </button>
            </Tooltip>
          </li>
        </ul>
      </div>
      <Activecall />
      <Contact />
      <div
        className="modal micromodal-slide"
        id="modal__mensagem-equipe"
        style={{ zIndex: "9999999999999999999999999" }}
        aria-hidden="true"
        role="dialog"
      >
        <TeamModal />
      </div>
    </div>
  );
}
